import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
import { ProjectsApiResponse, ProjectResponse } from "../types/projects-types";

export const fetchProject = createAsyncThunk(
  "project/fetchProject",
  async (slug: string, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get<ProjectsApiResponse>(
        `/projects?filters[slug][$eq]=${slug}&populate=*`
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

type ProjectsState = {
  project: null | ProjectResponse;
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
};

const initialState: ProjectsState = {
  project: null,
  status: "idle",
  error: null,
};

const projectSlice = createSlice({
  name: "project",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProject.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchProject.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.project = action.payload.data[0];
      })
      .addCase(fetchProject.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      });
  },
});

export default projectSlice.reducer;
